import { TemplateSystem } from "../../requests/templateBuilder/types";
import makeGuardsForModelSubset from "../makeGuardsForModelSubset";

const explicitSchema = {
  isDb: ["db"] as const,
  isHeg: ["heg"] as const,
};

type ApplicableKeys = keyof typeof explicitSchema;

type SchemaKey = keyof typeof explicitSchema;
type CompleteUnion = TemplateSystem;
type Groups = { [Key in SchemaKey]: typeof explicitSchema[Key][number] };

const criteria = <Key extends ApplicableKeys>(
  key: SchemaKey,
  system: TemplateSystem
): system is Groups[Key] => {
  const arr = explicitSchema[key];
  return arr.includes(system as never);
};

const guardsForSubset = makeGuardsForModelSubset<
  CompleteUnion,
  SchemaKey,
  Groups
>(criteria);

export default guardsForSubset;
